<div class="modal-header py-2">
    <h2 class="mb-0">Downgrading price plan</h2>
    <span class="icon icon-cross ml-auto py-1 px-2" (click)="response(false)"></span>
</div>
<div class="modal-body">
  <p *ngIf="isFreePlan() && !downgradeFromAnnual"> You are about to change your plan. Warning:
    the {{ accountFeatures }} features aren't available on the Free Plan and the monthly message limit
    is {{ pricePlan.limit | number }}.
  </p>
  <p *ngIf="isPremiumPlan() && !downgradeFromAnnual">
    You are about to change your plan. You will get full access to all
    features of the Premium plan. Your monthly message limit will be {{ pricePlan.limit | number }} messages.
    This will take effect on your next renewal date on {{ sub.expiration_date | trDateFormat: 'MM/DD/yy': timezone }}. You will be
    charged <strong>{{ (pricePlan.price / 100) | currency: 'USD' : 'symbol' : '1.0-0' }}</strong> at that time.
  </p>
  <p *ngIf="downgradeFromAnnual">
    You are about to change your plan. You will receive refund of the amount that was not
    used for the current plan and will be paid for new Premium plan. Your monthly message
    limit will be {{ pricePlan.limit | number }} messages. This will take effect immediately.
  </p>
</div>
<div class="modal-footer">
    <button
        type="submit"
        class="btn btn-primary mr-2"
        angularticsCategory="account"
        angulartics2On="click"
        angularticsAction="Confirm Downgrade"
        [disabled]="blockActions"
        (click)="response(true)"
    >Confirm</button>
    <button
        type="button"
        class="btn btn-danger"
        [disabled]="blockActions"
        (click)="response(false)"
    >Cancel</button>
</div>
